import { NavigateBackLink } from '@exam-center/components';
import { ExamCenterLocationRoomPhysicalInfoDetails } from '@exam-center/exam-center-location-details';
import { useParams } from '@exam-center/router';
import { Box, PageHeader, PaperSection } from '@shared/components';

export default function ExamCenterRoomPhysicalInfoPage() {
  const { examCenterCode, roomId } = useParams(
    '/:examCenterCode/exam-location/locations/:roomId/physical-info',
  );

  return (
    <>
      <PageHeader
        title='รายละเอียดข้อมูลลักษณะทางกายภาพ'
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-location/locations/:roomId'
            params={{ examCenterCode, roomId }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: 6 }}>
        <PaperSection title='ข้อมูลลักษณะทางกายภาพ'>
          <ExamCenterLocationRoomPhysicalInfoDetails />
        </PaperSection>
      </Box>
    </>
  );
}
